import { FeatureFlag } from '@piccolohealth/pbs-common';
import { ChakraV3 } from '@piccolohealth/ui';
import { inflection, P } from '@piccolohealth/util';
import React from 'react';

interface Props {
  value: FeatureFlag[];
  onChange: (value: FeatureFlag[]) => void;
}

export const FeatureFlagSwitches = (props: Props) => {
  const { value, onChange } = props;

  const featureFlags = P.omit(FeatureFlag, ['Placeholder']);

  return (
    <ChakraV3.CheckboxGroup
      value={value}
      onValueChange={(value) => onChange(value as FeatureFlag[])}
      colorPalette='brand'
    >
      {Object.entries(featureFlags).map(([key, flag]) => (
        <ChakraV3.HStack key={key} gap={2}>
          <ChakraV3.Checkbox value={flag} size='sm' />
          <ChakraV3.Text fontSize='sm'>{inflection.titleize(flag)}</ChakraV3.Text>
        </ChakraV3.HStack>
      ))}
    </ChakraV3.CheckboxGroup>
  );
};
